var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCopySimple = function SvgIconCopySimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.375a1 1 0 0 0 0 2h12.125V16.5a1 1 0 1 0 2 0V3.375a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.75 6.125a1 1 0 0 0-1 1V20.25a1 1 0 0 0 1 1h13.125a1 1 0 0 0 1-1V7.125a1 1 0 0 0-1-1zm1 13.125V8.125h11.125V19.25z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconCopySimple;